module.exports = __webpack_public_path__ + "static/media/_BID5555.68e60d5a.png";